import $ from 'jquery';
import ProductDetails from '../snippets/ProductDetails';

import ProductMenu from '../snippets/ProductMenu';

export default class Product {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);

    if (this.section.data.product === null) {
      return;
    }

    const { onboarding } = section.data;

    // Product details
    this.productDetails = new ProductDetails({ $el: this.$el, section });

    // Product menu
    if (!onboarding && !this.section.data.form_is_inline) {
      this.productMenu = new ProductMenu({
        el: this.section.el.querySelector('[data-product-menu]'),
        productEl: this.section.el,
        data: this.section.data,
        postMessage: this.section.postMessage,
      });
    }
  }

  onSectionMessage(name, data) {
    if (this.productMenu) {
      this.productMenu.onSectionMessage(name, data);
    }
  }

  onSectionUnload() {
    if (this.productMenu) this.productMenu.unload();
    if (this.productDetails) this.productDetails.unload();
  }
}
